import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CompanyInsightsHistoryMdoalComponent } from 'src/app/company-insights-history-mdoal/company-insights-history-mdoal.component';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { GlobalService } from 'src/app/_services/global.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import * as _ from "underscore";
import { MatAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/autocomplete';
import cjson from 'compressed-json';
import { Location } from '@angular/common';
declare const clevertap;


export interface SearchPayload {
  type: string;
  searchValue?: string;
  modalPayload?: object;
  searchFrom?: string;
}

type HISTORY_DATA = {
  type: string,
  name: string,
  companylogo: string | null,
  companyid: string | null,
  updatedon:string | null
}


@Component({
    selector: 'app-webbtree-company-search',
    templateUrl: './webbtree-company-search.component.html',
    styleUrls: ['./webbtree-company-search.component.scss'],
    standalone: false
})
export class WebbtreeCompanySearchComponent implements OnInit {

  typeaheaddata: any[] = [];
  typeahead_search: UntypedFormControl = new UntypedFormControl(null);
  companySearch: string;
  showMainSearchLoader:boolean = false;
  @Output('keywordSearchInput') keywordSearchInput: EventEmitter<SearchPayload> = new EventEmitter<SearchPayload>();
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;

  // @Input() btnColor:  { [key: string]: string } = {};//'#ffc400'; // Default color
  @Input() elementStyles: {
    button?: { [key: string]: string },
    label?: { [key: string]: string },
    searchinput?: { [key: string]: string },
    clearSearch?: { [key: string]: string },
    spinnerPosition?: { [key: string]: string }
  } = {};
  @Input() searchFrom: string;
    /** Recent search data contains unique 5 values from latest 10 searches */
    recentSearchData: HISTORY_DATA[] = [];

    /**Search history */
    historyData: HISTORY_DATA[] = [];
    @Input() scrollSearch;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
    searchKeyword: string;
    typeaheadSubscription: Subscription;
    @Input() searchvalue: string;

showCompanySearchLoader: boolean = false;
  constructor(private companyInsightsService: CompanyInsightsService, private personSearchService: PersonSearchService,
    private activeModal: NgbActiveModal,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private localStorageService: LocalStorageService, private hashService: HashService, private modalService: NgbModal,
    private router: Router,  private route: ActivatedRoute, private location: Location) {
       const cacheRequest = localStorage.getItem(this.route.snapshot.queryParams.filter);
          const filterData = cjson.decompress(JSON.parse(cacheRequest));
          this.loadDataFromLocalStorage(filterData);
           const statemanagementSub = this.location.subscribe((p) => {
                const filterKey = this.getFilterKeyFromUrl();
                   if (filterKey) {
                     const cached = localStorage.getItem(filterKey);
                     const filterData = cjson.decompress(JSON.parse(cached));
                   this.loadDataFromLocalStorage(filterData);
                   }

            })
     }

  ngOnInit() {
    if(this.searchvalue) {
      this.typeahead_search.patchValue(this.searchvalue);
    }
    this.companyInsightsService.fetchCompanySearchData.subscribe(res=>{
      this.typeahead_search.patchValue(res);

    })
    this.getHistory();

  }


  onTypeAheadSearch(event) {
    this.showCompanySearchLoader = true;
    this.showMainSearchLoader =true
     const input = event.target.value;
    if(input) {
      this.typeaheadSubscription &&  this.typeaheadSubscription.unsubscribe();

      this.typeaheadSubscription = this.companyInsightsService.getCompanyTypeaheads(input).subscribe((res:any)=>{
        this.showCompanySearchLoader = false;
    this.showMainSearchLoader =false

        const companyList = res.data.filter(typ=>typ.type == 'name');
        if(res?.data?.length){
          const companyLogoPayload = res?.data.map(item=>{
            if(item.id || item.value){
              return{
                ...(item?.id && {id: item.id}),
                ...(item?.value && {name: item.value})
              }
            }
          }).filter(Boolean);

          companyLogoPayload?.length &&
          this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((response: any) => {
            this.typeaheaddata = companyList.map(c => ({
              ...c, companylogo: response.data.filter(r => {
                if (r.searchedVia === 'id') {
                  return r.key === c.id;
                } else if (r.searchedVia === 'name') {
                  return r.key === c.value;
                }
              }
              )[0]?.companylogo
            }));
          });
        }
      })
    } else {
      this.companySearch = '';
      this.showMainSearchLoader = false;
      this.redirecttoAllListing();
    }


  }

   redirecttoAllListing(searchFrom?) {
    this.keywordSearchInput.emit({type: 'search',searchValue: this.companySearch, searchFrom: searchFrom });
  }

  selectTypeahead(data) {
    this.companySearch = data.value;
    this.typeahead_search.patchValue(this.companySearch);
    this.redirecttoAllListing('typeahead');
    this.companyInsightsService.setCompanySearschData(this.companySearch)

  }

  scrollTOCompareCompany(event, companyDetails) {
    event.stopPropagation();
    this.typeahead_search.patchValue('');
    this.companySearch = null;
    if (!this.companyInsightsService.companycompareone || this.companyInsightsService.companycompareone.length === 0) {
      this.companyInsightsService.companycompareone = [{ id: companyDetails.id, name: companyDetails.value,companylogo: companyDetails.companylogo ? companyDetails.companylogo: null }];
      this.localStorageService.setItem('companyOneId', companyDetails.id)
    } else if (!this.companyInsightsService.companycomparetwo || this.companyInsightsService.companycomparetwo.length === 0) {
      this.companyInsightsService.companycomparetwo = [{ id: companyDetails.id, name: companyDetails.value, companylogo: companyDetails.companylogo ? companyDetails.companylogo: null }];
      this.localStorageService.setItem('companyTwoId', companyDetails.id)

    } else {
      this.companyInsightsService.companycompareone = [{ id: companyDetails.id, name: companyDetails.value,companylogo: companyDetails.companylogo ? companyDetails.companylogo: null }];
      this.companyInsightsService.companycomparetwo = [];
      this.localStorageService.setItem('companyOneId', companyDetails.id)

    }

    const payload = {
      companyone: this.companyInsightsService.companycompareone,
      companytwo: this.companyInsightsService.companycomparetwo
    }


    this.companyInsightsService.sendCompanyCompareDetails(payload);
  }

  getDisabledCompareButton(companyId) {
    const companyOneId = this.localStorageService.getItem('companyOneId');
    const companyTwoId = this.localStorageService.getItem('companyTwoId');
    if(companyOneId && companyTwoId)
      return true;
    else if((companyOneId && companyOneId == companyId) && !companyTwoId)
      return true;
    else if(!companyOneId && (companyTwoId && companyTwoId == companyId))
      return true;
    else return false;
  }

  addCompanyForCompare(data) {
    const payload = {
      name: data.value,
      id: data.id
    }

    this.keywordSearchInput.emit({type: 'modal',modalPayload: {data: payload} });

    this.passEntry.emit(payload);
  }

  redirecttoCompanylist(company) {
    this.companyInsightsService.setCompanyListData(company);
    const companyinsightsFilter = this.filterDataHandlerService.fetchFilterData;
    this.localStorageService.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, JSON.stringify(companyinsightsFilter));
    const uniqueHash = this.hashService.generateUniqueHash();
      /**
           * Company Insights viewed
           */
         const companyInsightsParams = {
          "User ID": this.localStorageService.getItem('userdata').userid,
          "Company name": company.name,
          "Source": "search",
          "Filters Applied": "none"

        }
        clevertap.event.push("Company Insights Viewed",companyInsightsParams);
        this.localStorageService.setItem('companyCurrency', 'USD')
    const payload = {
      companies: [company.value],
      id: [company.id]
    }
    this.companyInsightsService.setCompanyInsightsHistory(payload, 'company');
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, companyinsightsFilter);
    const url = `/company-details/${company.id}?${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}`;
    window.open(url, "_blank");
  }

    /**
     * Get recent search history
     */
     async getHistory() {
      const { recentSearchData, historyData} = await this.companyInsightsService.getCompanyInsightsRecentSearchAndHistory();
      this.recentSearchData = recentSearchData;
      this.historyData = historyData;
    }

    /**Open company insights histroy modal */
    openSearchHistory(){
      const modalRef = this.modalService.open(CompanyInsightsHistoryMdoalComponent, { windowClass: "small-modal", centered: true });
      modalRef.componentInstance.historyData = this.historyData;
    }

      /**
   * Select recent history entery
   * @param data
   */
  selectRecentHistory(data) {
    this.modalService.dismissAll();
   // this.searchHistoryPagination = 0;
    if (data.type === 'company') {
     // this.setCompanyInsightsHistory({name: data.name, id: data.companyid}, 'company');
      this.redirecttoCompanylistHistory(data);
    } else if(data.type == 'company comparison') {
      if(data?.id?.length) {
        this.localStorageService.setItem('companyOneId', data.id[0]);
        this.localStorageService.setItem('companyTwoId', data.id[1].trim());
        this.router.navigate(['/company-compare']);
      }
    }
  }

  redirecttoCompanylistHistory(company) {
     this.companyInsightsService.setCompanyListData(company);
    const companyinsightsFilter = this.filterDataHandlerService.fetchFilterData;
    this.localStorageService.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, JSON.stringify(companyinsightsFilter));
    const uniqueHash = this.hashService.generateUniqueHash();
      /**
           * Company Insights viewed
           */
         const companyInsightsParams = {
          "User ID": this.localStorageService.getItem('userdata').userid,
          "Company name": company.name,
          "Source": "search",
          "Filters Applied": "none"

        }
        clevertap.event.push("Company Insights Viewed",companyInsightsParams);

    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, companyinsightsFilter);
    const url = `/company-details/${company.companyid}?${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}`;
    window.open(url, "_blank");
  }

  setCompanyInsightsHistory(data, selectionType: string) {
    const payload = {
      ...((selectionType === 'company') && {
        companies: data.companies,
        companyids:
          data.id
      }),
      module: GlobalService.HISTORY_MODULE.COMPANY_COMPARISON
    }
    this.personSearchService.setInsightsHistory(payload).subscribe();
  }

  search() {
  //  const inputkeyword = this.typeaheaddata.filter(x=>x.value.toLowerCase() == this.typeahead_search.value.toLowerCase())
    //if(inputkeyword.length > 0) {
      this.companySearch = this.typeahead_search.value;
      this.typeaheadSubscription &&  this.typeaheadSubscription.unsubscribe();
      this.typeaheaddata = [];
      if (this.autocompleteTrigger) {
        this.autocompleteTrigger.closePanel();
      }
      this.showMainSearchLoader = false;

      this.redirecttoAllListing();

    //}
  }

    capitalizeFirstLetter(str: string): string {
     return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  }

    loadDataFromLocalStorage(filterData) {
    if (filterData && filterData.search) {
      this.companySearch = filterData.search;
      this.typeahead_search.patchValue(this.companySearch);
    } else {
      this.companySearch = null;
      this.typeahead_search.patchValue(null);
    }

    if (filterData && filterData.searchFrom) {
      this.searchFrom = filterData.searchFrom;
    } else {
      this.searchFrom = null;
    }

  }

  private getFilterKeyFromUrl(): string | null {
    const params = new URLSearchParams(location.search);
    return params.get("filter");
  }

  clearSearch() {
    this.typeahead_search.patchValue('');
    this.companySearch = null;
    this.showMainSearchLoader = false;
    this.redirecttoAllListing();
   this.companyInsightsService.setCompanySearschData(this.companySearch)

  }
}
